module.exports = "<p>\n  general-stats works!\n</p>\n"